export function PageHeader({ title, description, actions, overline }) {
  return (
    <div className="mb-8 flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        {overline && (
          <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-primary/80">{overline}</p>
        )}
        <h2 data-testid="page-title" className="font-display text-[28px] font-bold leading-[1.1] tracking-tight sm:text-4xl">
          {title}
        </h2>
        {description && <p className="mt-2.5 max-w-2xl text-sm leading-relaxed text-muted-foreground">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </div>
  );
}
